/**
 * @generated SignedSource<<5993d8d5e8c9d3112729e721e1cb9acf>>
 * @relayHash 39e60bc16d8d4501c7ef742eadc32920
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9fa53d61b6f2a3f169b3a341b7875c023e74405a11a261bcd4bf2aa70a6661f

import type { ConcreteRequest } from 'relay-runtime';
export type InitAiFirstCreationExpMutation$variables = {
  cloudId: string;
};
export type InitAiFirstCreationExpMutation$data = {
  readonly confluence_experimentInitAiFirstCreation: {
    readonly success: boolean;
  } | null;
};
export type InitAiFirstCreationExpMutation = {
  response: InitAiFirstCreationExpMutation$data;
  variables: InitAiFirstCreationExpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceExperimentInitAiFirstCreationPayload",
    "kind": "LinkedField",
    "name": "confluence_experimentInitAiFirstCreation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InitAiFirstCreationExpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InitAiFirstCreationExpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39e60bc16d8d4501c7ef742eadc32920",
    "id": "f9fa53d61b6f2a3f169b3a341b7875c023e74405a11a261bcd4bf2aa70a6661f",
    "metadata": {},
    "name": "InitAiFirstCreationExpMutation",
    "operationKind": "mutation",
    "text": "mutation InitAiFirstCreationExpMutation($cloudId:ID!){confluence_experimentInitAiFirstCreation(cloudId:$cloudId){success}}"
  }
};
})();

(node as any).hash = "95c002f19a9d0165668939a53f08b109";

export default node;
